"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../button/Button"));

var _timesIcon = _interopRequireDefault(require("./timesIcon"));

require("./Message.css");

function Message(props) {
  var className = props.className,
      children = props.children,
      dismissible = props.dismissible,
      onDismiss = props.onDismiss,
      dismissType = props.dismissType,
      title = props.title,
      type = props.type,
      dismissText = props.dismissText,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["className", "children", "dismissible", "onDismiss", "dismissType", "title", "type", "dismissText"]);
  var isAlert = type === 'alert';
  var classNames = (0, _classnames["default"])(['stx-message', {
    'stx-message--with-alert': isAlert
  }, {
    'stx-message--with-warning': type === 'warning'
  }, {
    'stx-message--with-info': type === 'info'
  }, {
    'stx-message--with-success': type === 'success'
  }, className]);

  var timesIcon = /*#__PURE__*/_react["default"].createElement("span", {
    className: "stx-message-icon"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    className: "stx-message-icon__icon",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "stx-message-icon__path",
    fill: "#6B6B6B",
    d: _timesIcon["default"]
  })));

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: classNames,
    role: isAlert ? 'alert' : 'status'
  }, otherProps), title && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "stx-message__title"
  }, title), dismissible && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "stx-message__dismiss-button",
    "aria-label": dismissText,
    secondary: true,
    onClick: onDismiss
  }, dismissType === 'icon' ? timesIcon : dismissText), children);
}

Message.propTypes = {
  /** Optional className for the component */
  className: _propTypes["default"].string,

  /** Specify a type for the message to give it additional meaning */
  type: _propTypes["default"].oneOf(['alert', 'warning', 'success', 'info', '']),

  /** A special heading for the message */
  title: _propTypes["default"].string,

  /** Whether or not the message is dismissible */
  dismissible: _propTypes["default"].bool,

  /** Event called when the dismiss button is clicked */
  onDismiss: _propTypes["default"].func,

  /** Dismiss button type */
  dismissType: _propTypes["default"].oneOf(['string', 'icon']),

  /** Dismiss text for dismissType of string and aria label of dismiss button */
  dismissText: _propTypes["default"].string,

  /** Child elements */
  children: _propTypes["default"].node
};
Message.defaultProps = {
  dismissType: 'string',
  dismissText: 'Dismiss'
};
var _default = Message;
exports["default"] = _default;